import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncTidalToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.syncTidalToTidal}
            sections={<PairSyncGuideContent sourceKey="tidal" destKey="tidal" />}
        />
    );
}
